import { SubCompetency } from "@/lib/models";
import { getPerformanceLevelHierarchyFromId } from "@/lib/utils";
import { ProgressionArrow } from "../icons/ProgressionArrow";

type PerformanceLevelsProps = {
  subCompetency: SubCompetency;
};

export const PerformanceLevels = ({
  subCompetency,
}: PerformanceLevelsProps) => {
  const performanceLevels = [
    {
      id: subCompetency.performanceLevel1Id,
      description: subCompetency.performanceLevel1Description,
      name: getPerformanceLevelHierarchyFromId(
        subCompetency.performanceLevel1Id,
      ),
    },
    {
      id: subCompetency.performanceLevel2Id,
      description: subCompetency.performanceLevel2Description,
      name: getPerformanceLevelHierarchyFromId(
        subCompetency.performanceLevel2Id,
      ),
    },
    {
      id: subCompetency.performanceLevel3Id,
      description: subCompetency.performanceLevel3Description,
      name: getPerformanceLevelHierarchyFromId(
        subCompetency.performanceLevel3Id,
      ),
    },
    {
      id: subCompetency.performanceLevel4Id,
      description: subCompetency.performanceLevel4Description,
      name: getPerformanceLevelHierarchyFromId(
        subCompetency.performanceLevel4Id,
      ),
    },
  ];

  return (
    <div
      className="grid w-full grid-cols-1 pb-8 medium:grid-cols-4 medium:gap-4"
      role="row"
    >
      {performanceLevels.map((performanceLevel) => (
        <div
          key={performanceLevel.id}
          role="gridcell"
          aria-label={performanceLevel.id}
          className="text-base leading-5 medium:min-w-[160px] large:min-w-[223px] [&:not(:last-of-type)]:mb-7 medium:[&:not(:last-of-type)_svg]:inline"
        >
          <h6 className="mb-3 flex items-center font-roobert font-semibold text-dark-color">
            {performanceLevel.name}
            <ProgressionArrow className="left-3 hidden medium:relative" />
          </h6>
          <p className="font-roobert font-normal text-gray-text">
            {performanceLevel.description}
          </p>
        </div>
      ))}
    </div>
  );
};
